import { useMemo } from 'react';
import { usePersonalizedContent } from './usePersonalizedContent';
import { useIsPersonalizedContentEnabled } from './usePersonalizedParams';
export const usePersonalizedDescriptions = () => {
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    data,
    enabled,
    isLoading
  } = usePersonalizedContent();
  const byFamily = useMemo(() => {
    var _data$descriptions;
    const map = new Map();
    const items = data == null || (_data$descriptions = data.descriptions) == null ? void 0 : _data$descriptions.items;
    if (Array.isArray(items)) {
      items.forEach(item => map.set(item.productFamilyId, item.translation));
    }
    return map;
  }, [data]);
  return {
    getDescriptionTranslation: productFamilyId => isEnabled && productFamilyId ? byFamily.get(productFamilyId) : undefined,
    isLoading: enabled && isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedDescriptions.js.map